import useSWR from 'swr';

import { getApiKeysList, ApiKey } from '@/api/api-keys';
import { isDevEnv } from '@/libs/dev-logs';

type GetApiKeysListResponse = ApiKey[];

export const useGetApiKeys = (email: string | null) => {
  const { data, error, isLoading, mutate } = useSWR<GetApiKeysListResponse, Error>(
    email ? ['api-keys', email] : null,
    () => getApiKeysList(email!),
    { errorRetryCount: 1, revalidateOnFocus: !isDevEnv() }
  );

  return {
    error,
    apiKeys: data ?? [],
    loading: isLoading,
    refetch: mutate,
  };
};
